<template>
    <div id="mall">
        <keep-alive exclude="MallDetail">
            <router-view></router-view>
        </keep-alive>
        <main-tab-bar></main-tab-bar>
    </div>
</template>

<script>
    import MainTabBar from "./components/content/mainTabbar/MainTabBar";
    export default {
        name: "Mall",
        components: {MainTabBar},
    }
</script>

<style scoped>
@import "assets/css/base.css";
</style>